<template>
  <div
      :class="[component.type + '-container', 'content-item-container']"
      @click.capture="triggerSetTargetContentItem(component.id)">
    <headline-content-item
        v-if="component.type === 'headline'"
        :component="component"></headline-content-item>

    <text-content-item
        v-else-if="component.type === 'text'"
        :component="component"></text-content-item>

    <spacer-content-item
        v-else-if="component.type === 'spacer'"
        :component="component"></spacer-content-item>

    <button-content-item
        v-else-if="component.type === 'button'"
        :component="component"
        :style="{ pointerEvents: isEditor ? 'none' : 'all' }"></button-content-item>

    <image-content-item
        v-else-if="component.type === 'image'"
        :component="component"
        :is-target="!isPreview && (targetContentItemID === component.id || component.id === hoveredImageComponentId)"
        @mouseover.native="imageHovered(component.id, true)"
        @mouseleave.native="imageHovered(component.id, false)"></image-content-item>

    <social-content-item
        v-else-if="component.type === 'social'"
        :component="component"
        :style="{ pointerEvents: isEditor ? 'none' : 'all' }"></social-content-item>

    <voucher-content-item
        v-else-if="component.type === 'voucher'"
        :component="component"
        :voucher="voucher"></voucher-content-item>

    <field-content-item
        v-else-if="component.type === 'field'"
        :component="component"
        :validation="validation"></field-content-item>

    <rank-content-item
        v-else-if="component.type === 'rank'"
        :component="component"
        :validation="validation"></rank-content-item>

    <survey-content-item
        v-else-if="component.type === 'survey'"
        :component="component"
        :validation="validation"></survey-content-item>

    <checkbox-content-item
        v-else-if="component.type === 'checkbox'"
        :component="component"
        :validation="validation"></checkbox-content-item>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeadlineContentItem from './Headline/Headline.vue'
import TextContentItem from './Text/Text.vue'
import SpacerContentItem from './Spacer/Spacer.vue'
import FieldContentItem from './Field/Field.vue'
import ButtonContentItem from './Button/Button.vue'
import ImageContentItem from './Image/Image.vue'
import RankContentItem from './Rank/Rank.vue'
import SocialContentItem from './Social/Social.vue'
import SurveyContentItem from './Survey/Survey.vue'
import VoucherContentItem from './Voucher/Voucher.vue'
import CheckboxContentItem from './Checkbox/Checkbox.vue'

export default {
  name: 'ContentItemContainerComponent',
  components: {
    'headline-content-item': HeadlineContentItem,
    'text-content-item': TextContentItem,
    'spacer-content-item': SpacerContentItem,
    'field-content-item': FieldContentItem,
    'button-content-item': ButtonContentItem,
    'image-content-item': ImageContentItem,
    'rank-content-item': RankContentItem,
    'social-content-item': SocialContentItem,
    'survey-content-item': SurveyContentItem,
    'voucher-content-item': VoucherContentItem,
    'checkbox-content-item': CheckboxContentItem,
  },
  props: {
    component: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    voucher: {
      type: String,
      required: false,
      default: '',
    },
    isPreview: {
      required: false,
      type: Boolean,
      default: false,
    },
    isEditor: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveredImageComponentId: '',
    }
  },
  computed: {
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    ...mapState('campaign/contentItem', ['targetContentItemID']),
  },
  methods: {
    ...mapActions('campaign/contentItem', [
      'setTargetContentItem',
      'clearTargetContentItem',
    ]),
    imageHovered(componentId, mouseOver) {
      this.hoveredImageComponentId = mouseOver ? componentId : ''
    },
    triggerSetTargetContentItem(id) {
      if (!this.isPreview) {
        this.setTargetContentItem(id)
      }
    },
  },
}
</script>
